import './App.scss';
import { Routes, Route, Link } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Company from './pages/Company';
import Business from './pages/Business';
import Solution from './pages/Solution';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Routes>
        <Route path="/" element={<Home/>} />
        
        <Route path="/company" element={<Company/>} />
        <Route path="/business" element={<Business/>} />
        <Route path="/solution" element={<Solution/>} />
        {/* <Route path="/" element={<Home/>} /> */}
      </Routes>
      <Footer></Footer>
    </div>
  );
}

export default App;
